// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pie-chart-component .pie-label {
  margin: 5px 10px;
  display: flex;
  align-items: center;
}
.pie-chart-component .pie-label .pie-ball {
  margin-right: 10px;
  height: 10px;
  width: 10px;
  border-radius: 50%;
}
.pie-chart-component .pie-label .pie-data {
  display: flex;
  flex-direction: column;
}
.pie-chart-component .pie-label .pie-data .pie-title {
  font-weight: bold;
}
.pie-chart-component .pie-label .pie-data .pie-type-container {
  display: flex;
  flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/components/PieChart/index.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AAEI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;AADN;AAEM;EACE,iBAAA;AAAR;AAEM;EACE,aAAA;EACA,mBAAA;AAAR","sourcesContent":[".pie-chart-component {\n  .pie-label {\n    margin: 5px 10px;\n    display: flex;\n    align-items: center;\n\n    .pie-ball {\n      margin-right: 10px;\n      height: 10px;\n      width: 10px;\n      border-radius: 50%;\n    }\n\n    .pie-data {\n      display: flex;\n      flex-direction: column;\n      .pie-title {\n        font-weight: bold;\n      }\n      .pie-type-container {\n        display: flex;\n        flex-direction: row;\n        .pie-type {\n        }\n        .pie-numbers {\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
